export default "__VITE_ASSET__1737e7d4__"